/**
 * @file Automatically generated by barrelsby.
 */

export * from './form-control-error.component';
